module.exports = __webpack_public_path__ + "img/behavior_empty.db42a02b.png";